import { render } from "./LivescoringOnly.vue?vue&type=template&id=62978a51&scoped=true"
import script from "./LivescoringOnly.vue?vue&type=script&lang=js"
export * from "./LivescoringOnly.vue?vue&type=script&lang=js"

import "./LivescoringOnly.vue?vue&type=style&index=0&id=62978a51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62978a51"]])

export default __exports__